import { ILogger } from '@cian/logger';
import { IRegistry } from '@cian/mf-registry/browser';

import { IPayPackageMicrofrontendAPI } from '../types';

interface IParams {
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export const getPayPackageMicrofrontendAPI = (params: IParams): IPayPackageMicrofrontendAPI => {
  const { logger, microfrontendsRegistry } = params;

  const buyPackageApiCall = async <Params>(path: string, params?: Params): Promise<void> => {
    try {
      const api = await microfrontendsRegistry.microfrontendStrict('pay-package-frontend').api()!.ensure();

      return api.call(path, params);
    } catch (error) {
      logger.error(error, {
        domain: 'microfrontends.buy-package.api-call',
        details: { path, params: JSON.stringify(params) },
      });
    }
  };

  return {
    buyPackage: params => {
      return buyPackageApiCall('/v1/buy-package/', params);
    },
    buyCustomPackage: params => {
      return buyPackageApiCall('/v2/buy-custom-package/', params);
    },
  };
};
